import FilterCode from "!!raw-loader!./textfields/Filter.tsx";
import SearchCode from "!!raw-loader!./textfields/Search.tsx";
import TextFieldCode from "!!raw-loader!./textfields/TextField.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import Filter from "./textfields/Filter";
import Search from "./textfields/Search";
import TextField from "./textfields/TextField";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Text Field", TextFieldCode, TextField),
		paneComponent("Search Input", SearchCode, Search),
		paneComponent("Filter Input", FilterCode, Filter),
	];

	return (
		<Pane
			components={components}
			imports={"import {TextField} from \"designSystem/index\";"}
			muiApi="text-field"
			muiComponent="text-fields"
			{...props}
		/>
	);
};